var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input-number',{attrs:{"min":3,"max":100},on:{"change":_vm.handleChange},model:{value:(_vm.num),callback:function ($$v) {_vm.num=$$v},expression:"num"}})}
var staticRenderFns = []

export { render, staticRenderFns }